import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderNotesByOrderInput } from './GetOrderNotesByOrderInput';
import { GetOrderNotesByOrderOutput } from './GetOrderNotesByOrderOutput';

export class GetOrderNotesByOrderService extends HttpServiceBase {

  handle = (input: GetOrderNotesByOrderInput): Promise<Result<GetOrderNotesByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetOrderNotesByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/notes`);
    return promise;
  }
}